import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/scripts/AuthContext";
import {
  installAnalyticsLifecycle,
  trackPageView,
  flushAnalytics,
} from "@/lib/analytics";

/** Fires page_view on React Router navigations (public + authenticated). */
export default function AnalyticsRouteListener() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => installAnalyticsLifecycle(), []);

  useEffect(() => {
    trackPageView(pathname, isAuthenticated);
    return () => {
      void flushAnalytics();
    };
  }, [pathname, isAuthenticated]);

  return null;
}
